import { FC, PropsWithChildren } from 'react';
import { StyledWrapper } from './styles';
import { ISpacing } from '../spacing/spacing.types';

export const ContentBox: FC<PropsWithChildren<ISpacing>> = ({ children, ...rest }) => (
    <StyledWrapper {...rest}>{children}</StyledWrapper>
);
